import {useState} from 'react';
import cn from 'classnames';
import {AnimatePresence, motion} from 'framer-motion';
import {useTranslation} from 'next-i18next';
import BestSellerProductsMobile from '@/_application/modules/products/components/highlight-products-block/best-seller-products.mobile';
import HighlightProductsMobile from '@/_application/modules/products/components/highlight-products-block/highlight-products.mobile';
import NewArrivalProductsMobile from '@/_application/modules/products/components/highlight-products-block/new-arrival-products.mobile';
import {LazyLoadBlock} from '@/_application/core/components/commons/lazy-load-block';
enum sectionNameEnum {
    bestSeller = 0,
    highlight,
    new,
}

const HighlightProductBlockMobile = () => {
    const {t} = useTranslation();
    const [selectedSection, setSelectedSection] = useState<number>(sectionNameEnum.bestSeller);
    const sections = [
        {
            title: t('text-best-seller', 'Bán chạy'),
        },
        {
            title: t('text-popular', 'Nổi bật'),
        },
        {
            title: t('text-new'),
        },
    ];

    return (
        <div className="w-full py-4">
            <div className="w-full bg-white py-2">
                <ul className="ml-4 flex gap-6">
                    {sections.map((section, index) => (
                        <li key={`section-${section.title}`}>
                            <motion.button
                                className={cn('py-2 text-xs font-bold', {
                                    'text-primary': selectedSection === index,
                                    'text-gray-400': selectedSection !== index,
                                })}
                                onClick={() => setSelectedSection(index)}>
                                {section.title}
                            </motion.button>
                            {selectedSection === index && (
                                <motion.div className="border-b border-KPZ_Blue-Dark" layoutId="underline" />
                            )}
                        </li>
                    ))}
                </ul>

                <LazyLoadBlock isLazyLoad={true}>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={selectedSection || 'empty'}
                            initial={{y: 10, opacity: 0}}
                            animate={{y: 0, opacity: 1}}
                            exit={{y: -10, opacity: 0}}
                            transition={{duration: 0.2}}>
                            {selectedSection === sectionNameEnum.bestSeller && <BestSellerProductsMobile />}

                            {selectedSection === sectionNameEnum.highlight && <HighlightProductsMobile />}

                            {selectedSection === sectionNameEnum.new && <NewArrivalProductsMobile />}
                        </motion.div>
                    </AnimatePresence>
                </LazyLoadBlock>
            </div>
        </div>
    );
};

export default HighlightProductBlockMobile;
